import ICaseSummary from "../case/ICaseSummary";
import IUser from "../user/IUser";

export enum StorageItemType {
	File = 'File',
	Folder = 'Folder'
}

export interface IStoredItem {
    id: string;
    url: string;
    path: string;
    fullPath: string;
    created: number;
    createdBy: IUser;
    entityId: number;
    case: ICaseSummary;
    type: StorageItemType;
    contentType?: string;
    size: number;
    fileName?: string;
    typeName?: string;
    folderName?: string;
}